module.exports = __webpack_public_path__ + "static/img/Ben-Murdoch-Masila.817b19b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Ben-Murdoch-Masila.jpg
// module id = KkCu
// module chunks = 0